import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { NOTIFICATION_SERVICE } from '@eggplant/api-hosts'
import type { ReactElement } from 'react'

interface Props {
  id: string
  children?: () => ReactElement
  onSuccess?: () => void
}

const DeleteTestManagementIntegrationRequest = ({
  id,
  children,
  onSuccess
}: Props) => {
  const url = `${NOTIFICATION_SERVICE}/integrations/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='delete'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default DeleteTestManagementIntegrationRequest
